<template>
  <div class="main-container">
    <v-container class="pa-0" fluid>
      <div class="header-holder pl-3 pl-md-0 py-5">
        <h1 class="header">
          {{ $t("app_bar.title") }}
        </h1>
        <h4 class="sub-header">
          {{ $t("app_bar.university_name") }}
        </h4>
      </div>
      <LauncherTabs :page="page" />
      <v-card
        :disabled="loading"
        :loading="loading"
        color="rgb(255, 255, 255, 0.6)"
        class="pa-5"
      >
        <div class="black--text text-center pb-3">
          <h3>
            <router-link
              to="/announcement_tcas"
              style="text-decoration:none; color:black;"
              >{{ $t("announcement.announcement_tcas") }}</router-link
            >
          </h3>
        </div>
        <v-row>
          <v-col class="col-12 col-md-12">
            <v-card :color="tcas_current_page_round.color" dark>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title
                    class="text-decoration"
                    v-text="objectTranslator(tcas_current_page_round, 'title')"
                  ></v-card-title>

                  <v-card-subtitle
                    v-text="objectTranslator(tcas_current_page_round, 'detail')"
                  ></v-card-subtitle>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-12 col-md-12">
            <h4>{{ $t("explore.select_faculty_to_search") }}</h4>
            <v-autocomplete
              chips
              clearable
              dense
              deletable-chips
              multiple
              outlined
              v-model="tcas_falultiesSelected"
              v-bind:items="tcas_faculties"
              v-bind:item-text="
                (item) =>
                  inlineTranslator({
                    en: item.faculty_ename,
                    th: item.faculty_name,
                  })
              "
              v-bind:item-value="(item) => item.faculty_id"
              hide-details
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <div class="news-container pa-0 pa-sm-3 pa-xl-6">
          <v-card>
            <v-tabs v-model="tab" center-active dark>
              <v-tabs-slider color="brown"></v-tabs-slider>
              <v-tab
                href="#tab-1"
                class="font-weight-bold"
                style="background-color: #88E1FF"
              >
                {{ $t("announcement.application_announcement") }}
              </v-tab>
              <v-tab
                href="#tab-2"
                class="font-weight-bold"
                style="background-color: #FFEC73"
              >
                {{ $t("announcement.writing_information") }}
              </v-tab>
              <v-tab
                href="#tab-3"
                class="font-weight-bold"
                style="background-color: #FFA956"
              >
                {{ $t("announcement.interview_information") }}
              </v-tab>
              <v-tab
                href="#tab-4"
                class="font-weight-bold"
                style="background-color: #FF68A9;"
              >
                {{ $t("announcement.clearing_house") }}
              </v-tab>
              <v-tab
                href="#tab-5"
                class="font-weight-bold"
                style="background-color: #C8FF56"
              >
                {{ $t("announcement.qualified") }}
              </v-tab>
              <v-tab
                href="#tab-6"
                class="font-weight-bold"
                style="background-color: #C172FF;"
              >
                {{ $t("announcement.matriculation") }}
              </v-tab>
            </v-tabs>
            <v-tabs-items class="pl-4" style="color: #fcaf1e" v-model="tab" touchless v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
              {{ $t("announcement.swift") }}
            </v-tabs-items>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item
                v-for="(item_main, i) in news_type"
                :key="i"
                :value="item_main.tab_id"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>
                          #
                        </th>
                        <th>
                          {{ $t("announcement.title") }}
                        </th>
                        <th>
                          {{ $t("announcement.detail") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in item_main.type"
                        v-bind:key="item.news_id"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a
                            v-bind:href="item.link1"
                            target="_blank"
                            style="text-decoration:none"
                            >{{
                              inlineTranslator({
                                en: item.topic_en,
                                th: item.topic,
                              })
                            }}</a
                          >
                          <br />
                          <span style="float: left;">
                            <!-- <v-chip
                              class="ma-2"
                              color="#A9A9A9"
                              text-color="white"
                              x-small
                            >
                              {{ objectTranslator(item, "FACULTY_NAME") }}
                            </v-chip> -->
                          </span>
                          <span style="float: right;" class=" grey--text ">
                            { {{ item.date_time }} }
                          </span>
                        </td>
                        <td>
                          <span v-if="item.link1 && item.link2">
                            <div class="d-flex">
                              <ButtonNews
                                v-bind:text="filetype(item.link1)"
                                v-bind:link="item.link1"
                                color="primary"
                                class="mr-1"
                              />

                              <ButtonNews
                                v-bind:text="filetype(item.link2)"
                                v-bind:link="item.link2"
                                color="primary"
                              />
                            </div>
                          </span>
                          <span v-else>
                            <ButtonNews
                              v-bind:text="$t('announcement.detail')"
                              v-bind:link="item.link1"
                              color="primary"
                              mdi="mdi-link-variant"
                            />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import ButtonNews from "@/components/announcement/ButtonNews";
import AnnouncementProvider from "@/services/announcement.provider";
import LauncherTabs from "@/components/explore_page/LauncherTabs";
// import { getById } from "@/helper/filter";

const announcementProvider = new AnnouncementProvider();

export default {
  name: "AnnoucementTCASdetail",
  props: ["round"],
  data: function() {
    return {
      page: "undergraduate_announcement",
      tab: null,
      index: 1,
      loading: false,

      tcas_faculties: [],
      tcas_falultiesSelected: [],

      newsTCAS_application: [],
      newsTCAS_writing: [],
      newsTCAS_interview: [],
      newsTCAS_clearing: [],
      newsTCAS_qualified: [],
      newsTCAS_confirm: [],

      tcas_round: [
        {
          round: 1,
          color: "#385F73",
          link: "/announcement_tcas_detail",
          title_TH: "TCAS รอบที่ 1",
          detail_TH: "การรับด้วยแฟ้มสะสมผลงาน",
          title_EN: "TCAS round 1",
          detail_EN: "Admission by Portfolio",
        },
        {
          round: 2,
          color: "#385F73",
          link: "/announcement_tcas_detail",
          title_TH: "TCAS รอบที่ 2",
          detail_TH: "การรับแบบโควตา",
          title_EN: "TCAS round 2",
          detail_EN: "Quota Admission ",
        },
        {
          round: 3,
          color: "#385F73",
          link: "/announcement_tcas_detail",
          title_TH: "TCAS รอบที่ 3",
          detail_TH: "Admission",
          title_EN: "TCAS round 3",
          detail_EN: "Admission",
        },
        {
          round: 5,
          color: "#385F73",
          link: "/announcement_tcas_detail",
          title_TH: "TCAS รอบที่ 4",
          detail_TH: "รับตรงอิสระ",
          title_EN: "TCAS round 4",
          detail_EN: "Direct Admission",
        },
      ],
    };
  },
  components: {
    LauncherTabs,
    ButtonNews,
  },
  methods: {
    objectTranslator,
    inlineTranslator,

    filetype: function(filename) {
      const re = /(?:\.([^.]+))?$/;
      return re.exec(filename)[1];
    },

    async fetch_data() {
      const facultys = await announcementProvider.getTcasFaculty();
      this.tcas_faculties = facultys;

      const data1 = await announcementProvider.getNewsTCASs_application({
        round: this.round,
      });
      // data1.map((item) => {
      //   if (item.faculty_id) {
      //     const ref_data = getById(
      //       this.tcas_faculties,
      //       item.faculty_id,
      //       "faculty_id"
      //     );
      //     item.FACULTY_NAME_EN = ref_data.faculty_ename;
      //     item.FACULTY_NAME_TH = ref_data.faculty_name;
      //   }
      //   return item;
      // });
      this.newsTCAS_application = data1;

      const data2 = await announcementProvider.getNewsTCASs_writing({
        round: this.round,
      });
      this.newsTCAS_writing = data2;

      const data3 = await announcementProvider.getNewsTCASs_interview({
        round: this.round,
      });
      this.newsTCAS_interview = data3;

      const data4 = await announcementProvider.getNewsTCASs_clearing({
        round: this.round,
      });
      this.newsTCAS_clearing = data4;

      const data5 = await announcementProvider.getNewsTCASs_qualified({
        round: this.round,
      });
      this.newsTCAS_qualified = data5;

      const data6 = await announcementProvider.getNewsTCASs_confirm({
        round: this.round,
      });
      this.newsTCAS_confirm = data6;
    },
  },
  computed: {
    // เงื่อนไขการแสดงข้อมูลตามคณะที่เลือก
    filtered_newsTCAS_application() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_application;
      }

      return this.newsTCAS_application.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    filtered_newsTCAS_writing() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_writing;
      }

      return this.newsTCAS_writing.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    filtered_newsTCAS_interview() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_interview;
      }

      return this.newsTCAS_interview.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    filtered_newsTCAS_clearing() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_clearing;
      }

      return this.newsTCAS_clearing.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    filtered_newsTCAS_qualified() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_qualified;
      }

      return this.newsTCAS_qualified.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    filtered_newsTCAS_confirm() {
      if (this.tcas_falultiesSelected.length === 0) {
        return this.newsTCAS_confirm;
      }

      return this.newsTCAS_confirm.filter((item) =>
        this.tcas_falultiesSelected.includes(item.faculty_id)
      );
    },
    // แสดงประเภทข้อมูลแยกตาม tab
    news_type() {
      return [
        {
          tab_id: "tab-1",
          type: this.filtered_newsTCAS_application,
        },
        {
          tab_id: "tab-2",
          type: this.filtered_newsTCAS_writing,
        },
        {
          tab_id: "tab-3",
          type: this.filtered_newsTCAS_interview,
        },
        {
          tab_id: "tab-4",
          type: this.filtered_newsTCAS_clearing,
        },
        {
          tab_id: "tab-5",
          type: this.filtered_newsTCAS_qualified,
        },
        {
          tab_id: "tab-6",
          type: this.filtered_newsTCAS_confirm,
        },
      ];
    },

    tcas_current_page_round() {
      return this.tcas_round.find((item) => item.round === this.round);
    },
  },
  mounted: function() {
    this.loading = true;
    this.fetch_data();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.topic-container {
  background-color: #fffa;
  padding: 5px 25px 25px 25px;
  display: flex;
  flex-direction: column;
}
.main-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header-holder {
  padding-bottom: 20px;
}

.header {
  color: rgb(255, 255, 255);
  text-shadow: 1px 1px 1px #000000cc;
  font-weight: bold;
}

.sub-header {
  color: #ff3c00;
  background-color: rgba(255, 255, 255, 0.5);
  // padding: 0px 10px 0px 10px;
  width: auto;
  font-weight: bold;
}

.news-container {
  background-color: #0005;
  // padding: 20px;
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: rgba(0, 0, 0, 0.7);
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--inactive) {
  color: rgba(0, 0, 0, 0.7);
}

</style>
